class Gifting {
  constructor(giftProducts) {
    this.giftProducts = giftProducts
    this.variants = []
    this.selectedVariant = null
    this.variantButtons = document.querySelectorAll('.fc-gifting_product_card_option')
    this.toggleButtons = document.querySelectorAll('.fc-gifting_product_card_toggle')
    this.form = document.querySelector('.fc-gifting_form')
    this.formInputs = document.querySelectorAll('.fc-gifting_form input, .fc-gifting_form textarea')
    this.addToCartButton = document.querySelector('.fc-gifting_add_to_cart_button')
    this.validationErrors = {}
    this.init()
  }

  init() {
    this.bindEvents()
    this.getVariants()
  }

  bindEvents() {
    this.variantButtons.forEach((option) => {
      option.addEventListener('click', () => this.handleSelectVariant(option))
    })

    this.toggleButtons.forEach((toggle) => {
      toggle.addEventListener('click', () => this.handleToggleProductCard(toggle))
    })

    this.formInputs.forEach((input) => {
      input.addEventListener('input', () => this.onFormChange(input))
      input.addEventListener('blur', () => this.validateField(input))
    })

    this.addToCartButton.addEventListener('click', () => this.handleAddToCart())
  }

  getVariants() {
    this.variants = giftProducts.map((product) => product.variants).flat()
  }

  handleSelectVariant(variantButton) {
    this.variantButtons.forEach((option) => {
      option.classList.remove('selected')
    })
    variantButton.classList.add('selected')
    this.selectedVariant = this.variants.find((variant) => variant.id === parseInt(variantButton.dataset.variantId)) || null
    this.updateButtonState()
  }

  handleToggleProductCard(toggleButton) {
    toggleButton.closest('.fc-gifting_product_card').classList.add('open')
  }

  // Email validation using regex
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  // Validate individual field
  validateField(input) {
    const fieldName = input.name
    const value = input.value.trim()
    const formItem = input.closest('.fc-gifting-form_item')

    // Remove existing error message
    const existingError = formItem.querySelector('.error-message')
    if (existingError) {
      existingError.remove()
    }

    // Clear error state
    input.classList.remove('error')
    delete this.validationErrors[fieldName]

    // Validate required fields
    if (input.hasAttribute('required') && !value) {
      this.setFieldError(input, formItem, 'This field is required')
      return false
    }

    // Validate email format
    if (fieldName === 'email' && value) {
      if (!this.isValidEmail(value)) {
        this.setFieldError(input, formItem, 'Please enter a valid email address')
        return false
      }
    }

    // Validate confirm email
    if (fieldName === 'confirmEmail' && value) {
      const emailInput = this.form.querySelector('input[name="email"]')
      if (!this.isValidEmail(value)) {
        this.setFieldError(input, formItem, 'Please enter a valid email address')
        return false
      }
      if (value !== emailInput.value) {
        this.setFieldError(input, formItem, 'Emails do not match')
        return false
      }
    }

    // Validate sender email (optional but must be valid if provided)
    if (fieldName === 'senderEmail' && value) {
      if (!this.isValidEmail(value)) {
        this.setFieldError(input, formItem, 'Please enter a valid email address')
        return false
      }
    }

    return true
  }

  // Set error state and message
  setFieldError(input, formItem, message) {
    input.classList.add('error')
    this.validationErrors[input.name] = message

    const errorElement = document.createElement('span')
    errorElement.className = 'error-message'
    errorElement.textContent = message
    formItem.appendChild(errorElement)
  }

  // Validate all required fields
  validateForm() {
    let isValid = true
    const requiredInputs = this.form.querySelectorAll('input[required]')

    requiredInputs.forEach((input) => {
      if (!this.validateField(input)) {
        isValid = false
      }
    })

    // Also validate confirm email matching
    const emailInput = this.form.querySelector('input[name="email"]')
    const confirmEmailInput = this.form.querySelector('input[name="confirmEmail"]')

    if (emailInput.value && confirmEmailInput.value && emailInput.value !== confirmEmailInput.value) {
      isValid = false
    }

    return isValid
  }

  onFormChange(input) {
    // Validate the field that changed if it has been touched
    if (input && input.value) {
      this.validateField(input)

      // If email changed, also revalidate confirm email
      if (input.name === 'email') {
        const confirmEmailInput = this.form.querySelector('input[name="confirmEmail"]')
        if (confirmEmailInput.value) {
          this.validateField(confirmEmailInput)
        }
      }
    }

    this.updateButtonState()
  }

  updateButtonState() {
    const formData = new FormData(this.form)
    const data = Object.fromEntries(formData.entries())

    // Check if required fields are filled
    const requiredFieldsFilled = data.name && data.email && data.confirmEmail

    // Check if there are no validation errors
    const noErrors = Object.keys(this.validationErrors).length === 0

    // Check if a variant is selected
    const variantSelected = this.selectedVariant !== null

    const variantAvailable = this.selectedVariant?.available

    if (!variantAvailable) {
      this.addToCartButton.disabled = true
      this.addToCartButton.querySelector('strong').textContent = 'Not available'
    }

    // Enable button only if all conditions are met
    this.addToCartButton.disabled = !(requiredFieldsFilled && noErrors && variantSelected)
  }

  async handleAddToCart() {
    // Final validation before submission
    if (!this.validateForm()) {
      console.error('Form validation failed')
      return
    }

    if (!this.selectedVariant) {
      alert('Please select a gift option')
      return
    }

    const formData = new FormData(this.form)
    const data = Object.fromEntries(formData.entries())

    let payload = {
      items: [
        {
          id: this.selectedVariant.id,
          quantity: 1,
          properties: {
            __rc_gift_notification_scheduled_at: data.recipientNotificationDate || new Date().toISOString().split('T')[0],
            __rc_gift_sender_name: data.senderName || '',
            __rc_gift_sender_email: data.senderEmail || '',
            __rc_gift_recipient_note: data.message || '',
            __rc_gift_recipient_email: data.email,
            __rc_gift_recipient_last_name: data.name.split(' ')[1] || '',
            __rc_gift_recipient_first_name: data.name.split(' ')[0]
          }
        }
      ]
    }

    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
  }

}

new Gifting(giftProducts)
